const initialInsurance = {
    insurancePermissions: {},
    insuranceLists: [],
    insuranceHighlightedRecord: null,
    insuranceListsId:[],
    insuranceStatus: [],
    changedInsuranceStatus: [],
    loadingInsurance: false,
    errorsInsurance: {},
    deleteInsurance:false
}

const insuranceReducer = (insurance = initialInsurance, action) => {
    switch (action.type) {
        case "GET_INSURANCELIST_PENDING":
        case "ADD_CLIENT_BASIC_PENDING":
        case "ADD_CLIENT_AGREEMENT_PENDING":
        case "UPDATE_INSURANCE_PENDING":
        case "UPDATE_INSURANCE_STATUS_PENDING":
        case "DELETE_INSURANCE_PENDING":
        case "GET_INSURANCELISTBYID_PENDING":
        case "DELETE_INSURANCE_COMPANY_PENDING":
        case "SAVE_INSURANCE_COMPANY_REPORT_TEMPLATE_PENDING":
            return { ...insurance, loadingInsurance: true,deleteInsurance:false };

        case "GET_INSURANCELIST_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                insuranceLists: action.payload,
                updateId:action.payload?.data?.id  || insurance.updateId,
                insuranceCount: action.count,
                insurancePermissions: action.permissions,
            };

        case "ADD_CLIENT_BASIC_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                changedInsuranceStatus: action.payload,
                insuranceListsId:action.payload?.data,
                updateId:action.payload?.data?.id  || insurance.updateId,
                errorsInsurance: {},
                message: action.payload?.message,
            };

        case "ADD_CLIENT_AGREEMENT_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                changedInsuranceStatus: action.payload,
                insuranceListsId:action.payload?.data,
            };

        case "UPDATE_INSURANCE_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                insuranceListsId:action.payload?.data,
                updateId:action.payload?.data?.id  || insurance.updateId,
                changedInsuranceStatus: action.payload,
                errorsInsurance: {},
                changedInsuranceStatus: action.payload,
            };

        case "UPDATE_INSURANCE_STATUS_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                changedInsuranceStatus: action.payload,
            };

        case "GET_INSURANCELISTBYID_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                insuranceListsId: action.payload,
                updateId:action.payload?.id,
              
            };

        case "DELETE_INSURANCE_COMPANY_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                deleteInsurance:true
            };

        case "DELETE_INSURANCE_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                changedInsuranceStatus: action.payload
            };

        case "SAVE_INSURANCE_COMPANY_REPORT_TEMPLATE_FULFILLED":
            return {
                ...insurance,
                loadingInsurance: false,
                changedInsuranceStatus: action.payload,
                insuranceListsId: action.payload?.data,
                updateId: action.payload?.data?.id || insurance.updateId,
                errorsInsurance: {},
                message: action.payload?.message,
            };

        case "RESET_DELETE_INSURANCE_STATUS":
            return {
                ...insurance,
                loadingInsurance: false,
                insuranceStatus: {},
                changedInsuranceStatus: [],
                errorsInsurance: {},
                message:"",
                updateId: null,
                insuranceListsId: [],
            };

        case "GET_INSURANCELIST_REJECTED":
        case "ADD_CLIENT_BASIC_REJECTED":
        case "ADD_CLIENT_AGREEMENT_REJECTED":
        case "UPDATE_INSURANCE_REJECTED":
        case "UPDATE_INSURANCE_STATUS_REJECTED":
        case "DELETE_INSURANCE_REJECTED":
        case "GET_INSURANCELISTBYID_REJECTED":
        case "DELETE_INSURANCE_COMPANY_REJECTED":
        case "SAVE_INSURANCE_COMPANY_REPORT_TEMPLATE_REJECTED":
            return {
                ...insurance,
                loadingInsurance: false,
                errorsInsurance: action.payload,
                deleteInsurance:false
            };
        case "SET_INSURANCE_HIGHLIGHTED_RECORD":
            return {
                ...insurance,
                insuranceHighlightedRecord: action.payload,
            };
        case "CLEAR_INSURANCE_HIGHLIGHTED_RECORD":
            return {
                ...insurance,
                insuranceHighlightedRecord: null,
            };
        default:
            return insurance;
    }
}

export default insuranceReducer;